import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Input from './../../components/UI/Input/index';
import { updateOrderDiscountedTotalAmount, updateOrderVisibleDiscountedTotal } from '../../actions';
import { useDispatch } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CheckAmountInWords from '../../components/CheckAmountInWords';

const TotalAmountContainer = ({ totalAmount, handleTotalAmount, orderItem }) => {
    const dispatch = useDispatch();
    const { visibleDiscountedTotal, discountedAmount, discountForBuyers } = orderItem || {};

    const [show, setShow] = useState(false);
    const [discountPercentage, setDiscountPercentage] = useState(discountedAmount > 1 ? discountedAmount : "");
    const [_discountForBuyers, setDiscountForBuyers] = useState(discountForBuyers > 1 ? discountForBuyers : "");
    const [error, setError] = useState("");

    const isValidObjectId = (id) => typeof id === "string" && /^[0-9a-fA-F]{24}$/.test(id);

    const handleChangeTotalAmountDiscount = () => {
        const percent = parseFloat(discountPercentage);
        const total = totalAmount?.();

        if (isNaN(percent) || percent < 0 || percent > 100 || isNaN(total)) {
            setError("Некорректные данные для расчета скидки.");
            return;
        }

        const discounted = total * (1 - percent / 100);
        setDiscountForBuyers(Math.round(discounted * 100) / 100);
        setError("");
    };

    const handleSubmitOrderDiscount = () => {
        if (!isValidObjectId(orderItem?._id)) {
            console.warn("❌ orderItem._id некорректный:", orderItem?._id);
            setError("Некорректный ID заказа.");
            return;
        }

        const payload = {
            discountedAmount: discountPercentage,
            discountForBuyers: _discountForBuyers,
            orderId: orderItem._id
        };

        dispatch(updateOrderDiscountedTotalAmount(payload));
    };

    const handleUpdateOrderVisibleDiscountedTotal = () => {
        if (!isValidObjectId(orderItem?._id)) {
            console.warn("❌ Неверный ID при обновлении видимости скидки:", orderItem?._id);
            return;
        }

        dispatch(updateOrderVisibleDiscountedTotal({ orderId: orderItem._id }));
    };

    const renderAllPrices = () => (
        <div className="renderOrderDetails__allPriceContainer">
            <div className="renderOrderDetails__priceBox">
                <p>Общая сумма:&nbsp;</p>
                <span>{orderItem.totalAmount} $</span>
            </div>
            <div className="renderOrderDetails__priceDiscountedBox">
                <p>Установленный процент скидки:&nbsp;</p>
                <span>{orderItem.discountedAmount} %</span>
            </div>
            <div className="renderOrderDetails__fixedPercentage">
                <p>Общая сумма со скидкой:&nbsp;</p>
                <span><CheckAmountInWords amount={orderItem.discountForBuyers} /></span>
            </div>
        </div>
    );

    return (
        <div className="renderOrderDetails__totalPriceContainer">
            {orderItem.disableFunctionality ? renderAllPrices() : (
                <Button
                    style={{ marginTop: "20px" }}
                    variant="contained"
                    onClick={() => setShow(!show)}
                >
                    Настройки Стоимости {show ? "скрыть" : "показать"}
                </Button>
            )}

            {show && (
                <div className="renderOrderDetails__rowTotalAmount">
                    <div className="renderOrderDetails__mainContent">
                        <div className="renderOrderDetails__titleTotalPrice">Общая сумма</div>
                        {totalAmount() > 0 ? (
                            <div className="renderOrderDetails__totalPrice">
                                <CheckAmountInWords amount={totalAmount()} />
                            </div>
                        ) : (
                            <div className="renderOrderDetails__noTotalPrice">
                                Не везде указана сумма!
                            </div>
                        )}

                        <Button
                            variant="contained"
                            onClick={() => handleTotalAmount(totalAmount())}
                        >
                            Подтвердить сумму
                        </Button>

                        <div style={{ marginTop: "15px" }}>
                            <Button
                                endIcon={visibleDiscountedTotal ? <VisibilityOffIcon /> : <AddIcon />}
                                variant="contained"
                                color={visibleDiscountedTotal ? "success" : "error"}
                                onClick={handleUpdateOrderVisibleDiscountedTotal}
                            >
                                {visibleDiscountedTotal ? "Скрыть" : "Добавить"} скидку
                            </Button>
                        </div>
                    </div>

                    {visibleDiscountedTotal && (
                        <div className="renderOrderDetails__mainContent">
                            <Input
                                label="Процент"
                                name="discountPercentage"
                                value={discountPercentage}
                                placeholder="Введите процент"
                                onChange={(e) => setDiscountPercentage(e.target.value)}
                            />
                            {discountPercentage !== "" && (
                                <Button variant="outlined" onClick={handleChangeTotalAmountDiscount}>
                                    Посчитать
                                </Button>
                            )}
                            <div className="renderOrderDetails__titleTotalPrice">
                                Сумма после вычета скидки!
                            </div>
                            {_discountForBuyers > 0 ? (
                                <div className="renderOrderDetails__totalPrice">
                                    {_discountForBuyers} $
                                </div>
                            ) : (
                                <div className="renderOrderDetails__noTotalPrice">
                                    Нужно указать число в процентах
                                </div>
                            )}

                            <Button
                                variant="contained"
                                onClick={handleSubmitOrderDiscount}
                            >
                                Сохранить сумму со скидкой
                            </Button>

                            {error && (
                                <div style={{ marginTop: 10, color: 'red' }}>
                                    {error}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default TotalAmountContainer;
